import BundlePrice from '../../Bundles/BundlePrice';
import { Box, Stack } from '@mui/material';
import { SpecialOfferProps } from '../types';
import { StyledSpecialOffer } from './style';
import {
    EBundlesInternalViewModel,
    EProductPriority
} from '../../Helper/enums';
import {
    calculateSaleStrokedNumber,
    formattingNumber,
    useCountdown
} from '../../Helper/utils/utils';
import { HuuugeSaleBadge } from '../../Badge/Sale/HuuugeSaleBadge';
import BundleSubProduct from '../../Products/sub';

function SpecialOffer({
    text,
    price,
    design,
    textColor,
    borderColor,
    buttonColor,
    productsList,
    availability,
    endTimeActive,
    backgroundColor,
    backgroundImage,
    endTime,
    selectOffer,
    inMobileMock = false,
    salePercentage = 0,
    salePercentageDisplayType,
    amountBeforeSale,
    isFree,
    productsQuantityFormat,
    availabilityText = 'Available',
    collectText = 'Collect',
    specialOfferRef
}: SpecialOfferProps) {
    const mainProducts = productsList.filter(
        (product) => product.priority === EProductPriority.MAIN
    );
    const subProducts = productsList.filter(
        (product) => product.priority === EProductPriority.SUB
    );
    const onlyMain = subProducts.length === 0;
    const countdown = endTimeActive && endTime ? useCountdown(endTime) : '';
    const availabilityString =
        availability?.remaining && availability?.total
            ? `${availabilityText} ${availability.remaining}/${availability.total}`
            : '';

    return (
        <StyledSpecialOffer
            ref={specialOfferRef}
            borderColor={borderColor}
            backgroundColor={backgroundColor}
            backgroundImage={backgroundImage}
            textColor={textColor}
            productsHeight={onlyMain ? '33%' : '50%'}
            mainHeight={onlyMain ? '100%' : '60%'}
            boxPadding={
                design === EBundlesInternalViewModel.AK ? '8px 0' : '8px 0 0 0'
            }
            onClick={selectOffer}
            title={text}
            mainProductsLength={mainProducts.length}
            subProductsLength={subProducts.length}
        >
            <Box className="backgroundImage">
                {salePercentage > 0 && (
                    <HuuugeSaleBadge
                        salePercentage={salePercentage}
                        salePercentageDisplayType={salePercentageDisplayType}
                    />
                )}
                {design !== EBundlesInternalViewModel.MATCH && <h2>{text}</h2>}
                {design === EBundlesInternalViewModel.MATCH && (
                    <h2
                        className="match"
                        style={{
                            marginTop: '0.5em',
                            fontSize: '2em'
                        }}
                    >
                        {text}
                    </h2>
                )}
                {/* <h1>{JSON.stringify(mainProducts)}</h1> */}
                <Box
                    className={`productsContainer ${
                        design !== EBundlesInternalViewModel.MATCH
                            ? 'huuuge'
                            : 'match'
                    }${
                        mainProducts.length + subProducts.length > 4
                            ? 'manyProducts'
                            : ''
                    }`}
                >
                    {design !== EBundlesInternalViewModel.MATCH ? (
                        <Box className="products mainProducts huuuge">
                            {mainProducts.map((product, index) => {
                                return (
                                    index === 0 && (
                                        <Box className="product" key={index}>
                                            {product.images.product && (
                                                <Box
                                                    height="32px"
                                                    width="32px"
                                                    className="image-container"
                                                >
                                                    <img
                                                        src={
                                                            product.images
                                                                .product
                                                        }
                                                        alt=""
                                                        className="image-container--image"
                                                    />
                                                </Box>
                                            )}
                                            <Box
                                                display="flex"
                                                flexDirection="column"
                                                alignItems="center"
                                            >
                                                <h4
                                                    data-text={
                                                        product.quantityDisplay
                                                    }
                                                >
                                                    {product.quantityDisplay}
                                                </h4>
                                                {salePercentage > 0 && (
                                                    <p className="stroked">
                                                        {amountBeforeSale ??
                                                            `${formattingNumber(
                                                                calculateSaleStrokedNumber(
                                                                    product.quantity,
                                                                    salePercentage,
                                                                    salePercentageDisplayType
                                                                ),
                                                                productsQuantityFormat
                                                            )}`}
                                                    </p>
                                                )}
                                            </Box>
                                        </Box>
                                    )
                                );
                            })}
                        </Box>
                    ) : (
                        // IF MATCH MASTERS
                        <Stack
                            className="products mainProducts match"
                            direction="row"
                        >
                            {mainProducts.map((product, index) => {
                                return (
                                    <Stack
                                        className="product__match"
                                        alignItems="center"
                                        key={index}
                                    >
                                        {product.images.product && (
                                            <Box
                                                height="62px"
                                                width="62px"
                                                className="image-container--match"
                                            >
                                                <img
                                                    src={product.images.product}
                                                    alt=""
                                                    className="image-container--image"
                                                />
                                            </Box>
                                        )}
                                        <Box
                                            display="flex"
                                            flexDirection="row"
                                            alignItems="center"
                                        >
                                            {product?.images?.productPrefix && (
                                                <Box
                                                    pr={1}
                                                    sx={{
                                                        height: '20px'
                                                    }}
                                                >
                                                    <img
                                                        src={
                                                            product.images
                                                                .productPrefix
                                                        }
                                                        alt=""
                                                        style={{
                                                            maxHeight: '20px',
                                                            objectFit: 'cover'
                                                        }}
                                                    />
                                                </Box>
                                            )}
                                            <h4
                                                data-text={
                                                    product.quantityDisplay
                                                }
                                            >
                                                {product.quantityDisplay}
                                            </h4>
                                        </Box>
                                    </Stack>
                                );
                            })}
                        </Stack>
                    )}
                    {design !== EBundlesInternalViewModel.MATCH &&
                        mainProducts.concat(subProducts).length > 0 && (
                            <>
                                <Box className="products secondaryProduct">
                                    {mainProducts
                                        .concat(subProducts)
                                        .map((product, i) => {
                                            if (i === 0) return;
                                            return (
                                                <BundleSubProduct
                                                    key={i}
                                                    itemClassName={
                                                        'carousel-item'
                                                    }
                                                    textFontColorHex={'white'}
                                                    quantityDisplay={
                                                        product.quantityDisplay
                                                    }
                                                    productType={
                                                        product.productType
                                                    }
                                                    quantity={product.quantity}
                                                    index={i - 1}
                                                    images={product.images}
                                                    rarityProductInfo={
                                                        product.rarityProductInfo
                                                    }
                                                    itemRef={specialOfferRef}
                                                    badgeText={
                                                        product.badgeText
                                                    }
                                                    isFullWidth={false}
                                                />
                                            );
                                        })}
                                </Box>
                            </>
                        )}
                </Box>
                {endTimeActive && (
                    <span className="availability countdown">{countdown}</span>
                )}
                {availabilityString && (
                    <span className="availability quantity">
                        {availabilityString}
                    </span>
                )}
                <BundlePrice
                    whiteStripe={design !== EBundlesInternalViewModel.MATCH}
                    height="30px"
                    price={price}
                    buttonTextColor="white"
                    buttonColor={buttonColor}
                    type={design}
                    textShadow="0px 2px 0px #000000"
                    borderRadius="0 0 9px 9px"
                    isPreview={inMobileMock}
                    isFree={isFree}
                    buttonText={collectText}
                />
            </Box>
        </StyledSpecialOffer>
    );
}

export default SpecialOffer;
